<ng-container [formGroup]="salaryFormGroup">
  <rt-form-field [hasLabelMargin]="false" [hideRequiredBadge]="true" class="range-field">
    <rt-label [hasRequiredBadge]="hasRequiredAsterisk" margin-bottom-small-xx>
      {{ 'app.offer_form.salary' | translate }}
      <rt-icon-help [rtTooltip]="'app.offer_form.salary_tooltip' | translate" margin-left-small-xx>
      </rt-icon-help>
    </rt-label>
    <div class="salary-range">
      <rt-numeric-input
        [rtProtectedControl]="salaryFormGroup.controls['min']"
        [placeholder]="'app.common.min' | translate"
        [disabled]="isDisabled"
        [readOnly]="isReadOnly"
        [updateFormattedValueDispatcher$]="updateFormattedValueDispatcher"
        formControlName="min"
      ></rt-numeric-input>
      <span padding-lr-small-x>{{ 'app.offer_form.to' | translate }}</span>
      <rt-numeric-input
        [rtProtectedControl]="salaryFormGroup.controls['max']"
        [placeholder]="'app.common.max' | translate"
        [disabled]="isDisabled"
        [readOnly]="isReadOnly"
        [updateFormattedValueDispatcher$]="updateFormattedValueDispatcher"
        formControlName="max"
      ></rt-numeric-input>
    </div>
    @if (showErrorMessages) {
      @if (showNotNumberError) {
        <span text-red padding-top-small-xx>{{
          'app.offer_form.errors_new_validation.salary.not_number' | translate
        }}</span>
      } @else if (showNotGraterThanOrEqualZeroError) {
        <span text-red padding-top-small-xx>{{
          'app.offer_form.errors_new_validation.salary.not_grater_than_or_equal_zero' | translate
        }}</span>
      } @else if (showRangeError) {
        <span text-red padding-top-small-xx>{{
          'app.offer_form.errors_new_validation.salary.range' | translate
        }}</span>
      }
    }
  </rt-form-field>
  <rt-form-field class="period-field">
    <rt-select
      [options]="salaryPeriodSelectOptions"
      [placeholder]="'app.offer_form.period_placeholder' | translate"
      [rtProtectedControl]="salaryFormGroup.controls['period']"
      [includeEmptyOption]="true"
      [hasInputTrigger]="true"
      [isInvalid]="!salaryFormGroup.controls['period'].valid"
      [disabled]="isDisabled"
      [readOnly]="isReadOnly"
      formControlName="period"
    >
    </rt-select>
  </rt-form-field>
  <rt-form-field class="currency-field">
    <rt-currency-select-field
      [form]="salaryFormGroup.controls['currency']"
      [placeholder]="'app.offer_form.currency_placeholder' | translate"
      [isDisabled]="isDisabled"
      [isReadOnly]="isReadOnly"
      [isInvalid]="salaryFormGroup.controls['currency'].invalid"
    >
    </rt-currency-select-field>
    @if (showErrorMessages && salaryFormGroup.controls['currency'].invalid) {
      <span text-red padding-top-small-xx>{{
        'app.offer_form.errors_new_validation.currency.required' | translate
      }}</span>
    }
  </rt-form-field>
</ng-container>
